import { util } from 'pevueglobal'
import { Validator } from 'vee-validate'
import { store } from '@/store/'
Validator.extend('truthy', {
  getMessage: field => 'The ' + field + ' value is not truthy.',
  validate: value => !!value
})

// server validatie voor metavelden
const serverValidate = (
  value,
  { rowID, tblname, fieldValues, tblDynamicDataRetrieveDefinitionIDCustomvalidator } = {}
) => {
  let valueToSend = ''
  // als de waarde een array is dan komma gescheiden maken
  if (Array.isArray(value)) {
    value.forEach(v => {
      valueToSend = valueToSend + v + ','
    })
    valueToSend = valueToSend.substring(0, valueToSend.length - 1)
    console.log(valueToSend)
  } else {
    valueToSend = value
  }
  // server validatie uitvoeren
  return new Promise(resolve => {
    util
      .getDataApi('public/PEapi_ValidateMetadata/', {
        rowID: rowID,
        tablename: tblname,
        input: valueToSend.toString(),
        fields: fieldValues,
        tblDynamicDataRetrieveDefinitionIDCustomvalidator: tblDynamicDataRetrieveDefinitionIDCustomvalidator
      })
      .then(async data => {
        if (data.isValid === 1) {
          return resolve({
            valid: true
          })
        }
        console.log(data)
        return resolve({
          valid: false,
          data: {
            message: data.ErrorMessage
          }
        })
      })
  })
}

// Algemene server validatie
const customServerValidate = async (value, { validatorApiRoute, parameters } = {}) => {
  // server validatie uitvoeren
  const data = await util.getDataApi(validatorApiRoute, { value, ...parameters })
  const { isValid: valid, errorMessage } = data.ds.data0[0]

  return {
    valid,
    data: {
      message: valid ? undefined : errorMessage
    }
  }
}

export function InitServerValidator() {
  const paramNames = ['rowID', 'tblname', 'fieldValues']
  Validator.extend(
    'serverValidate',
    {
      validate: serverValidate,
      getMessage: (field, params, data) => {
        if (data.message === '') {
          return field + ' ' + store.getters.translation(83)
        } else {
          return data.message
        }
      }
    },
    { paramNames }
  )

  const paramNamesCustomServerValidate = ['validatorApiRoute']
  Validator.extend(
    'customServerValidate',
    { validate: customServerValidate, getMessage: (field, params, data) => data.message },
    { paramNamesCustomServerValidate }
  )
}
